module.exports = __webpack_public_path__ + "img/bg_2.d287b7d6.png";